import React from 'react'
import styles from './TRoutePhotos.scss'
import { showGallery } from 'features/gallery/showGallery'
import { galleryMessages } from 'features/gallery/Gallery'
import { Image } from 'common/Image'
import { Msg, commonNouns } from 'lib/localization'
import _ from 'lodash'
import { FormattedMessage as T, defineMessages, injectIntl } from 'react-intl'

const message = defineMessages({
  youCanAlso: {
    id: 'TRoutePhotos.youCanAlso',
    defaultMessage: 'You can also add photos by dragging them onto this page'
  }
})

class _TRoutePhotos extends React.PureComponent {
  render () {
    const {
      editable,
      objectType,
      onTriggerFileBrowser,
      pendingPhotoUploads,
      photos,
      troute,
      onPhotoDeleted,
      intl
    } = this.props
    const orderedPhotos = _.orderBy(photos, ['capturedAt', 'id'], ['asc', 'asc'])
    const showGalleryWithProps = (activePhotoId) => showGallery({
      photos: orderedPhotos,
      readonly: !editable,
      parentType: objectType,
      parentId: troute.id,
      activePhotoId,
      onPhotoDeleted,
      coverId: troute.highlightedPhotoId
    })

    if (photos.length === 0) {
      if (editable && !pendingPhotoUploads) {
        return <div className={styles.TRoutePhotos}>
          <h2><Msg capitalized m={commonNouns.photos} values={{ count: 0 }} /></h2>
          <T
            id='TRoutePhotos.noPhotos'
            defaultMessage='Drag photos onto this page or click <a>here</a> to add photos to this {objectType}.'
            values={{ a: (...c) => <a onClick={onTriggerFileBrowser}>{c}</a>, objectType }} />
        </div>
      } else { return null }
    }

    return (
      <div className={styles.TRoutePhotos}>
        {orderedPhotos.length === 1 && <Image
          id={orderedPhotos[0].id}
          width={360}
          height={240}
          onClick={() => showGalleryWithProps(orderedPhotos[0].id)} />}
        {orderedPhotos.length > 1 && <div className={styles.grid}>
          {orderedPhotos.slice(0, 6).map(p => (
            <Image key={p.id}
              id={p.id}
              width={112}
              height={112}
              onClick={() => showGalleryWithProps(p.id)} />
          ))}
        </div>}
        {orderedPhotos.length > 0 && <div className={styles.morePhotos}>
          <span>
            <a onClick={showGalleryWithProps}>
              <Msg m={galleryMessages.openGallery} />
            </a> ({photos.length} <Msg m={commonNouns.photos} values={{ count: photos.length }} />)
          </span>
          {editable && <a onClick={onTriggerFileBrowser} data-tip title={intl.formatMessage(message.youCanAlso)}>
            <T id='TRoutePhotos.addPhotos' defaultMessage='Add photos' />
          </a>}
        </div>}
      </div>
    )
  }
}

export const TRoutePhotos = injectIntl(_TRoutePhotos)
